import { gql } from "@apollo/client";

export const QR_LIST_CONVERSATION = gql`
  query listConversation(
    $paginationParams: BaseCollection!
    $establishmentId: String
    $customerId: String
    $assignedAgentId: String
    $status: ConversationStatusEnum
  ) {
    QR_LIST_CONVERSATION(
      paginationParams: $paginationParams
      establishmentId: $establishmentId
      customerId: $customerId
      assignedAgentId: $assignedAgentId
      status: $status
    ) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        totalElements
        totalPages
        currentPage
        content {
          id
          participants
          tripReference
          tripPublicationId
          establishmentId
          customerId
          assignedAgentId
          status
          lastMessage {
            content
            sendingDate
            status
          }
        }
      }
    }
  }
`;

export const QR_GET_CONVERSATION = gql`
  query getConversation($conversationId: String!) {
    QR_GET_CONVERSATION(conversationId: $conversationId) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        id
        participants
        tripReference
        tripPublicationId
        establishmentId
        customerId
        assignedAgentId
        status
      }
    }
  }
`;

export const MT_ADD_CONVERSATION = gql`
  mutation addConversation($conversationInput: ConversationInput!) {
    MT_ADD_CONVERSATION(conversationInput: $conversationInput) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        id
      }
    }
  }
`;

// La subscription `messageReceived` (Message) a été supprimée côté backend.
// `notificationAdded` (MESSAGE | TASK | RESERVATION) est désormais l'unique canal temps réel.
export const NOTIFICATION_ADDED_SUBSCRIPTION = gql`
  subscription OnNotificationAdded {
    notificationAdded {
      resource
      resourceId
      receiverId
      establishmentId
      notificationType
    }
  }
`;

export const MT_SEND_MESSAGE = gql`
  mutation sendMessage($message: MessageInput!) {
    MT_SEND_MESSAGE(message: $message) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        id
        conversationId
        content
        sendingDate
        receiverId
        status
      }
    }
  }
`;

export const QR_LIST_MESSAGE = gql`
  query listMessage(
    $paginationParams: BaseCollection!
    $conversationId: String!
  ) {
    QR_LIST_MESSAGE(
      paginationParams: $paginationParams
      conversationId: $conversationId
    ) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        totalElements
        totalPages
        currentPage
        content {
          id
          content
          receiverId
          sendingDate
          status
        }
      }
    }
  }
`;
